import React from 'react';
import { t } from 'i18next';
import { connect } from 'react-redux';
import { logOut as logOutAction } from 'src/state/UserSession';
import {
  LogoutButton,
  LogoutIcon,
  LogoutText,
  MvpLogoutButton,
  MvpLogoutIcon,
} from './PortalLogoutButton.styles';
import { useUrlParameterCheck } from 'src/utils/useUrlParameterCheck';

interface IProps {
  logOut: typeof logOutAction;
}

const PortalLogoutButton = ({ logOut }: IProps) => {
  const buttonText = t('LogOut');
  const isFromMvpApp = useUrlParameterCheck('/app');

  return isFromMvpApp ? (
    <MvpLogoutButton onClick={logOut} aria-label={buttonText}>
      <MvpLogoutIcon />
    </MvpLogoutButton>
  ) : (
    <LogoutButton onClick={logOut} aria-label={buttonText}>
      <LogoutText>{buttonText}</LogoutText>
      <LogoutIcon type="logout" />
    </LogoutButton>
  );
};

export default connect(null, {
  logOut: logOutAction,
})(PortalLogoutButton);
